import {
  Box,
  Badge,
  Divider,
  useTheme,
  Typography,
  Tooltip,
  IconButton,
  Menu,
  Avatar,
  Drawer,
  Chip,
  Tabs,
  Tab,
  List,
  ListItem,
  Icon,
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Rating,
  CircularProgress,
  Snackbar,
  Alert,
  Switch,
  Backdrop,
  TextField,
  Button,
} from "@mui/material";
import { useState, useEffect } from "react";
import { Storage } from "aws-amplify";
import { Link as RouterLink } from "react-router-dom";
import { useThemeContext } from "../utils/ThemeContext";
import { usePanelTokens } from "../utils/panelTokens";
import { useUserContext } from "../context/UserContext";
import {
  listSubscriptions,
  listServices,
} from "./newBackendApi/newSubscriptions";
import { getPlanById } from "./newBackendApi/newPlans";

// --- MUI Icons ---
// These are icon components from @mui/icons-material package
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import NotificationsOffIcon from "@mui/icons-material/NotificationsOff";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import FeedbackIcon from "@mui/icons-material/Feedback";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import SendIcon from "@mui/icons-material/Send";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import StoreOutlinedIcon from "@mui/icons-material/StoreOutlined";

// --- Redux & Router ---
import { connect } from "react-redux";
import * as actions from "../store/actions/api/auth";
import * as pageActions from "../store/actions/pageContextActions";
import { withRouter } from "../hooks/withRouter";
import NavSearch from "./NavSearch";
import OrgSwitcher from "./OrgSwitcher";
import { AssistantLauncher } from "./assistant";
import { ROUTES } from "../routes";

const Navbar2 = (props) => {
  const theme = useTheme();

  const { themeMode, toggleTheme } = useThemeContext();
  const T = usePanelTokens();

  const [userServices, setUserServices] = useState([]);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [unreadCount] = useState(0);
  const [notifications] = useState([]);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [notificationTab, setNotificationTab] = useState(0);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [feedbackSubmitting] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [profilePictureUrl, setProfilePictureUrl] = useState("");

  // accountsAnchorEl stores which element the menu should appear below
  // null = menu is closed, element = menu is open below that element
  const [accountsAnchorEl, setAccountsAnchorEl] = useState(null);

  // Profile data object — stores all user info
  const [profileData, setProfileData] = useState({
    fullName: "",
    email: "",
    profilePicture: "",
    preferredUsername: "",
    givenName: "",
    familyName: "",
  });
  const { userDetails, sub } = useUserContext();

  const [feedbackData, setFeedbackData] = useState({
    rating: 0,
    category: "",
    message: "",
    email: "",
  });

  const feedbackCategories = [
    "Bug Report",
    "Feature Request",
    "UI/UX Improvement",
    "Performance Issue",
    "General Feedback",
  ];

  // Boolean: is the accounts menu open?
  const openAccountsMenu = Boolean(accountsAnchorEl);

  // --- NOTIFICATION FILTER ---
  // Returns different notifications based on which tab is selected
  const getFilteredNotifications = () => {
    switch (notificationTab) {
      case 0:
        return notifications;
      case 1:
        return notifications.filter((n) => !n.read);
      case 2:
        return notifications.filter((n) => n.type === "security");
      case 3:
        return notifications.filter((n) => n.type === "billing");
      default:
        return notifications;
    }
  };

  // --- EVENT HANDLERS ---
  const handleLogout = () => {
    setIsLoggingOut(true);
    setAccountsAnchorEl(null);
    props.logout(); // calls Redux action to clear auth state
  };

  const handleAccountsMenuOpen = (event) => {
    // event.currentTarget = the element that was clicked
    setAccountsAnchorEl(event.currentTarget);
  };

  const handleAccountsMenuClose = () => {
    setAccountsAnchorEl(null);
  };

  const handleNotificationOpen = () => setNotificationOpen(true);
  const handleNotificationClose = () => setNotificationOpen(false);
  const handleNotificationTabChange = (event, newValue) =>
    setNotificationTab(newValue);

  const handleSettingsOpen = () => setSettingsOpen(true);
  const handleSettingsClose = () => setSettingsOpen(false);


  const handleFeedbackClose = () => {
    setFeedbackOpen(false);
    setFeedbackData({ rating: 0, category: "", message: "", email: "" });
  };

  // Converts a Unix timestamp to "X mins ago" format

  // --- EFFECTS ---

  // This runs whenever userDetails changes
  useEffect(() => {
    if (userDetails) {
      setProfileData({
        fullName:
          `${userDetails.user_first_name || ""} ${userDetails.user_last_name || ""}`.trim() ||
          userDetails.user_email?.split("@")[0] ||
          "Unknown",
        email: userDetails.user_email || "Unknown",
        profilePicture: userDetails.user_profile_s3_key || "",
        preferredUsername: userDetails.user_email || "Unknown",
        givenName: userDetails.user_first_name || "",
        familyName: userDetails.user_last_name || "",
      });
    }
  }, [userDetails]);

  // Fetch the profile picture from AWS S3 when profilePicture key changes
  useEffect(() => {
    const fetchProfilePicture = async () => {
      if (profileData.profilePicture) {
        try {
          const url = await Storage.get(profileData.profilePicture, {
            level: "private",
          });
          setProfilePictureUrl(url);
        } catch (err) {
          setProfilePictureUrl("");
        }
      }
    };
    fetchProfilePicture();
  }, [profileData.profilePicture]);

  useEffect(() => {
    if (!sub) return;

    const fetchData = async () => {
      try {
        const [subRes, svcRes] = await Promise.all([
          listSubscriptions(sub),
          listServices(),
        ]);

        const subscriptions = subRes?.subscriptions || [];
        const services = svcRes?.services || [];

        const merged = await Promise.all(
          subscriptions.map(async (subscription) => {
            const svc = services.find((s) => s.id === subscription.service_id);

            const planDetails = await getPlanById(subscription.plan_id);

            return {
              ...subscription,
              service_name: svc?.service_name || subscription.service_id,
              plan_name: planDetails?.plan?.plan_name || "",
            };
          }),
        );

        setUserServices(merged);
      } catch (error) {
        console.error("Failed to fetch user services:", error);
      }
    };

    fetchData();
  }, [sub]);

  // ============================================================
  // RENDER
  // The navbar sits at the very top. Height is 54px.
  // Layout: [hamburger + logo + brand name] -------- [icons + user]
  // ============================================================
  return (
    <Box
      sx={{
        // position relative so dropdowns (absolute) position against this bar
        position: "relative",
        display: "flex",
        alignItems: "center",
        height: "54px",
        background: themeMode ? "#000" : "#ffffff",
        borderBottom: `1px solid ${themeMode ? "#1a1a1a" : "#e2e8f0"}`,
        padding: "0 18px",
        zIndex: 20, // stays above other content
        flexShrink: 0,
      }}
    >
      {/* ── LEFT SIDE: Brand Logo & Name ─────────────────────── */}

      {/* Global search — find pages / devices or ask the assistant (⌘K) */}
      <NavSearch />

      {/* ── RIGHT SIDE: Icons + User ──────────────────────────── */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "14px",
          flexShrink: 0,
        }}
      >
        {/* Marketplace — opens the Vecros store */}
        <Tooltip title="Marketplace" arrow>
          <IconButton
            aria-label="marketplace"
            onClick={() => window.open("https://store.vecros.com/", "_blank")}
            sx={{ padding: "6px", color: themeMode ? "#8899bb" : "#475569" }}
          >
            <StoreOutlinedIcon sx={{ fontSize: "20px" }} />
          </IconButton>
        </Tooltip>

        {/* Help — opens the Vecros community */}
        <Tooltip title="Help" arrow>
          <IconButton
            aria-label="help"
            onClick={() => window.open("https://discuss.vecros.com/", "_blank")}
            sx={{ padding: "6px", color: themeMode ? "#8899bb" : "#475569" }}
          >
            <HelpOutlineOutlinedIcon sx={{ fontSize: "20px" }} />
          </IconButton>
        </Tooltip>

        {/* Sun/Moon icon — toggles dark/light theme */}
        <Tooltip
          title={themeMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
          arrow
        >
          <IconButton
            onClick={toggleTheme}
            sx={{ padding: "6px", color: themeMode ? "#8899bb" : "#475569" }}
          >
            {themeMode ? (
              <LightModeOutlinedIcon sx={{ fontSize: "20px" }} />
            ) : (
              <DarkModeOutlinedIcon sx={{ fontSize: "20px" }} />
            )}
          </IconButton>
        </Tooltip>

        {/* Bell icon — opens the notifications drawer */}
        <Tooltip title="Notifications" arrow>
          <IconButton
            onClick={handleNotificationOpen}
            sx={{ padding: "6px", color: themeMode ? "#8899bb" : "#475569" }}
          >
            <Badge
              badgeContent={unreadCount}
              color="error"
              sx={{
                "& .MuiBadge-badge": {
                  fontSize: "10px",
                  minWidth: "16px",
                  height: "16px",
                },
              }}
            >
              <NotificationsOutlinedIcon sx={{ fontSize: "20px" }} />
            </Badge>
          </IconButton>
        </Tooltip>

        {/* Settings — opens the settings pane (app shell only, never public) */}
        <Tooltip title="Settings" arrow>
          <IconButton
            onClick={handleSettingsOpen}
            sx={{ padding: "6px", color: themeMode ? "#8899bb" : "#475569" }}
          >
            <SettingsOutlinedIcon sx={{ fontSize: "20px" }} />
          </IconButton>
        </Tooltip>

        {/* Divider before the AI assistant launcher */}
        <Divider
          orientation="vertical"
          sx={{
            height: "25px",
            borderColor: themeMode ? "#1a1a1a" : "#e2e8f0",
          }}
        />

        {/* AI Assistant — opens the docked assistant panel */}
        <AssistantLauncher />

        {/* Organisation switcher — which org the session acts as */}
        <OrgSwitcher />

        {/* Thin vertical divider line between icons and user */}
        <Divider
          orientation="vertical"
          sx={{
            height: "25px",
            borderColor: themeMode ? "#1a1a1a" : "#e2e8f0",
          }}
        />

        {/* User avatar + name + dropdown arrow — clicking opens account menu */}
        <Box
          onClick={handleAccountsMenuOpen}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer",
          }}
        >
          {/* Show actual profile picture if available, otherwise show a person icon */}
          {profileData.profilePicture ? (
            <Avatar
              src={profilePictureUrl || "/placeholder.svg"}
              sx={{ width: 28, height: 28, border: "1px solid #2a3040" }}
            />
          ) : (
            <Avatar sx={{ width: 28, height: 28, background: "#2a3040" }}>
              <PersonIcon sx={{ fontSize: 16, color: "#556677" }} />
            </Avatar>
          )}

          <Typography
            sx={{
              fontSize: "13px",
              color: themeMode ? "#8899bb" : "#475569",
              letterSpacing: "0.08em",
            }}
          >
            {/* Show name if available, otherwise fall back to email */}
            {profileData.fullName || profileData.email || "VECROS"}
          </Typography>

          {/* Small downward arrow */}
          <ArrowDropDownIcon
            sx={{ fontSize: "18px", color: themeMode ? "#8899bb" : "#475569" }}
          />
        </Box>
      </Box>

      {/* ── NOTIFICATIONS DRAWER ──────────────────────────────── */}
      {/* Drawer slides in from the right side of the screen */}
      <Drawer
        anchor="right"
        open={notificationOpen}
        onClose={handleNotificationClose}
        sx={{
          "& .MuiDrawer-paper": {
            width: 420,
            borderRadius: "16px 0 0 16px",
            backgroundColor: theme.palette.secondary.main,
          },
        }}
      >
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
          {/* Drawer Header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "20px 24px 16px",
              borderBottom: `1px solid ${theme.palette.divider}`,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <NotificationsActiveIcon
                sx={{ color: theme.palette.text.color, fontSize: 24 }}
              />
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Notifications
              </Typography>
              {unreadCount > 0 && (
                <Chip label={unreadCount} size="small" color="error" />
              )}
            </Box>
            <IconButton onClick={handleNotificationClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Tabs: All / Unread / Security / Billing */}
          <Box sx={{ borderBottom: `1px solid ${theme.palette.divider}` }}>
            <Tabs
              value={notificationTab}
              onChange={handleNotificationTabChange}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                "& .MuiTab-root": {
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: "14px",
                  color: theme.palette.text.color,
                },
                "& .Mui-selected": { color: "#006BCE" },
                "& .MuiTabs-indicator": { backgroundColor: "#006BCE" },
              }}
            >
              <Tab label="All" />
              <Tab label="Unread" />
              <Tab label="Security" />
              <Tab label="Billing" />
            </Tabs>
          </Box>

          {/* Notifications list or empty state */}
          <Box sx={{ flex: 1, overflow: "auto" }}>
            {getFilteredNotifications().length === 0 ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "200px",
                  color: theme.palette.text.secondary,
                }}
              >
                <NotificationsOffIcon
                  sx={{ fontSize: 48, mb: 2, opacity: 0.5 }}
                />
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  No notifications
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.7 }}>
                  You're all caught up!
                </Typography>
              </Box>
            ) : (
              <List sx={{ padding: 0 }}>
                {getFilteredNotifications().map((notification) => (
                  <ListItem
                    key={notification.id}
                    sx={{
                      padding: "16px 24px",
                      borderBottom: `1px solid ${theme.palette.divider}`,
                    }}
                  >
                    <ListItemAvatar>
                      <Box
                        sx={{
                          backgroundColor: notification.color,
                          color: "#fff",
                          width: 40,
                          height: 40,
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Icon>{notification.icon}</Icon>
                      </Box>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 600 }}
                        >
                          {notification.title}
                        </Typography>
                      }
                      secondary={
                        <Typography variant="body2">
                          {notification.message}
                        </Typography>
                      }
                    />
                    <ListItemSecondaryAction>
                      <IconButton size="small">
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))}
              </List>
            )}
          </Box>
        </Box>
      </Drawer>

      {/* ── SETTINGS PANE ─────────────────────────────────────── */}
      {/* Slides in from the right, same idiom as the notifications drawer. */}
      <Drawer
        anchor="right"
        open={settingsOpen}
        onClose={handleSettingsClose}
        sx={{
          "& .MuiDrawer-paper": {
            width: 420,
            borderRadius: "16px 0 0 16px",
            backgroundColor: theme.palette.secondary.main,
          },
        }}
      >
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "20px 24px 16px",
              borderBottom: `1px solid ${theme.palette.divider}`,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <SettingsOutlinedIcon
                sx={{ color: theme.palette.text.color, fontSize: 24 }}
              />
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Settings
              </Typography>
            </Box>
            <IconButton onClick={handleSettingsClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Box sx={{ flex: 1, overflowY: "auto", padding: "24px" }}>
            {/* ── Appearance ── */}
            <Typography
              sx={{
                fontSize: "10px",
                color: T.textMuted,
                fontWeight: 700,
                letterSpacing: "0.12em",
                mb: 1.5,
              }}
            >
              APPEARANCE
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                background: T.ground,
                border: `1px solid ${T.border}`,
                borderRadius: "8px",
                padding: "12px 16px",
                mb: 3,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                {themeMode ? (
                  <DarkModeOutlinedIcon
                    sx={{ fontSize: 18, color: T.textMuted }}
                  />
                ) : (
                  <LightModeOutlinedIcon
                    sx={{ fontSize: 18, color: T.textMuted }}
                  />
                )}
                <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                  Dark mode
                </Typography>
              </Box>
              {/* Same toggleTheme the navbar icon uses, so the two stay in sync. */}
              <Switch
                checked={themeMode}
                onChange={toggleTheme}
                inputProps={{ "aria-label": "Toggle dark mode" }}
              />
            </Box>

            {/* ── Profile ── */}
            <Typography
              sx={{
                fontSize: "10px",
                color: T.textMuted,
                fontWeight: 700,
                letterSpacing: "0.12em",
                mb: 1.5,
              }}
            >
              PROFILE
            </Typography>
            <Box
              sx={{
                background: T.ground,
                border: `1px solid ${T.border}`,
                borderRadius: "8px",
                padding: "16px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                {profileData.profilePicture ? (
                  <Avatar
                    src={profilePictureUrl || "/placeholder.svg"}
                    sx={{ width: 44, height: 44, border: "1px solid #2a3040" }}
                  />
                ) : (
                  <Avatar sx={{ width: 44, height: 44, background: "#2a3040" }}>
                    <PersonIcon sx={{ fontSize: 22, color: "#556677" }} />
                  </Avatar>
                )}
                <Box sx={{ minWidth: 0 }}>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 600,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {profileData.fullName || "VECROS"}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: T.textMuted,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {profileData.email}
                  </Typography>
                </Box>
              </Box>
              <Button
                fullWidth
                variant="outlined"
                startIcon={<EditOutlinedIcon sx={{ fontSize: "16px" }} />}
                component={RouterLink}
                to={ROUTES.profile}
                onClick={handleSettingsClose}
                sx={{
                  mt: 2,
                  textTransform: "none",
                  fontSize: "12px",
                  color: T.accent,
                  borderColor: T.accent,
                  borderRadius: "5px",
                }}
              >
                Edit profile
              </Button>
            </Box>
          </Box>
        </Box>
      </Drawer>

      {/* ── ACCOUNT DROPDOWN MENU ─────────────────────────────── */}
      {/* MUI Menu component — appears below the user avatar when clicked */}
      <Menu
        open={openAccountsMenu}
        anchorEl={accountsAnchorEl} // position menu below the clicked element
        onClose={handleAccountsMenuClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        sx={{
          "& .MuiMenu-paper": {
            width: 320,
            borderRadius: "10px",
            boxShadow: "0 10px 40px rgba(0,0,0,0.6)",
            border: `1px solid ${T.border}`,
            background: T.ground,
            padding: "16px 20px",
            marginTop: "8px",
            overflow: "hidden",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          },
          "& .MuiMenu-list": {
            padding: 0,
          },
        }}
      >
        {/* DEVELOPERS Section */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1.5,
          }}
        >
          <Typography
            sx={{
              fontSize: "10px",
              color: T.textMuted,
              fontWeight: 700,
              letterSpacing: "0.12em",
            }}
          >
            DEVELOPERS
          </Typography>
          <Typography
            component={RouterLink}
            to={ROUTES.profile}
            onClick={handleAccountsMenuClose}
            sx={{
              fontSize: "11px",
              color: T.accent,
              cursor: "pointer",
              fontWeight: 600,
              textDecoration: "none",
              "&:hover": { color: "#1460cc" },
            }}
          >
            My Account
          </Typography>
        </Box>
        <Typography
          sx={{
            fontSize: "14px",
            color: "#ffffff",
            fontWeight: 500,
            textDecoration: "underline",
            mb: 0.5,
            cursor: "pointer",
          }}
        >
          {profileData.email}
        </Typography>
        <Typography sx={{ fontSize: "11px", color: T.textMuted, mb: 2 }}>
          Usage: 0 devices
        </Typography>

        <Divider sx={{ borderColor: "#121212", my: 2 }} />

        {/* SERVICE PLAN Section */}
        <Typography
          sx={{
            fontSize: "12px",
            color: T.textMuted,
            fontWeight: 700,
            letterSpacing: "0.12em",
            mb: 1.5,
          }}
        >
          Plan :{" "}
          {userServices[0]?.plan_name ? userServices[0].plan_name : "Plan"}
        </Typography>
        <Box
          sx={{
            background: T.ground,
            border: `1px solid ${T.border}`,
            borderRadius: "8px",
            p: "16px",
            mb: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 0.5,
            }}
          >
            <Typography
              sx={{
                fontSize: "13px",
                color: "#ffffff",
                fontWeight: 600,
                letterSpacing: "0.02em",
              }}
            >
              {userServices[0]?.service_name || "VCS_WAREHOUSE"}
            </Typography>
            <Box
              sx={{
                px: 1,
                py: 0.2,
                borderRadius: "4px",
                background: userServices[0]?.is_active
                  ? "rgba(34, 197, 94, 0.1)"
                  : "rgba(239, 68, 68, 0.1)",
                border: `1px solid ${userServices[0]?.is_active ? "rgba(34, 197, 94, 0.2)" : "rgba(239, 68, 68, 0.2)"}`,
              }}
            >
              <Typography
                sx={{
                  fontSize: "9px",
                  color:
                    userServices[0]?.status === "active"
                      ? "#22c55e"
                      : "#ef4444",
                  fontWeight: 700,
                  textTransform: "uppercase",
                }}
              >
                {userServices[0]?.status === "active" ? "Active" : "Inactive"}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1.5,
            }}
          >
            <Typography sx={{ fontSize: "11px", color: T.textMuted }}>
              {userServices[0]?.plan_name || "Enterprise Plan"}
            </Typography>
            <Typography sx={{ fontSize: "11px", color: T.textMuted }}>
              {userServices[0]?.end_date
                ? `Valid till: ${new Date(userServices[0].end_date).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}`
                : "Valid till: 31 Dec 2026"}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              component={RouterLink}
              to={ROUTES.plansBilling}
              onClick={handleAccountsMenuClose}
              sx={{
                fontSize: "12px",
                color: T.accent,
                cursor: "pointer",
                fontWeight: 600,
                "&:hover": { color: "#1460cc" },
              }}
            >
              Manage Billing
            </Typography>
            <Button
              component={RouterLink}
              to={ROUTES.plans}
              onClick={handleAccountsMenuClose}
              variant="outlined"
              size="small"
              startIcon={
                <CreditCardOutlinedIcon sx={{ fontSize: "12px !important" }} />
              }
              sx={{
                textTransform: "none",
                fontSize: "11px",
                color: T.accent,
                borderColor: T.accent,
                py: 0.4,
                px: 1.5,
                borderRadius: "5px",
                fontWeight: 600,
                backgroundColor: "transparent",
                "&:hover": {
                  borderColor: "#1460cc",
                  background: "rgba(58, 142, 255, 0.08)",
                },
              }}
            >
              Upgrade Plan
            </Button>
          </Box>
        </Box>

        <Divider sx={{ borderColor: "#121212", my: 2 }} />

        {/* RESOURCES Section */}
        <Typography
          sx={{
            fontSize: "10px",
            color: T.textMuted,
            fontWeight: 700,
            letterSpacing: "0.12em",
            mb: 2,
          }}
        >
          RESOURCES
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 2,
            mb: 2,
          }}
        >
          <Box
            onClick={() => {
              handleAccountsMenuClose();
              window.open("https://docs.vecros.com/", "_blank");
            }}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              cursor: "pointer",
              color: T.textMuted,
              "&:hover": { color: "#ffffff" },
            }}
          >
            <HelpOutlineOutlinedIcon
              sx={{ fontSize: "16px", color: "inherit" }}
            />
            <Typography sx={{ fontSize: "13px", color: "inherit" }}>
              Help
            </Typography>
          </Box>
          <Box
            component={RouterLink}
            to={ROUTES.plans}
            onClick={handleAccountsMenuClose}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              cursor: "pointer",
              color: T.textMuted,
              "&:hover": { color: "#ffffff" },
            }}
          >
            <LocalOfferOutlinedIcon
              sx={{ fontSize: "16px", color: "inherit" }}
            />
            <Typography sx={{ fontSize: "13px", color: "inherit" }}>
              Pricing
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 2,
            mb: 1,
          }}
        >
          <Box sx={{ display: "flex", gap: 1.5 }}>
            <Typography
              onClick={() => window.open("/terms", "_blank")}
              sx={{
                fontSize: "11px",
                color: T.textMuted,
                cursor: "pointer",
                "&:hover": { color: T.accent },
              }}
            >
              Terms of services
            </Typography>
            <Typography
              onClick={() => window.open("/privacy", "_blank")}
              sx={{
                fontSize: "11px",
                color: T.textMuted,
                cursor: "pointer",
                "&:hover": { color: T.accent },
              }}
            >
              Privacy policy
            </Typography>
          </Box>
          <Typography sx={{ fontSize: "10px", color: T.textMuted }}>
            Version v2.0
          </Typography>
        </Box>

        <Divider sx={{ borderColor: "#121212", my: 2 }} />

        {/* Footer Actions */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Box
            component={RouterLink}
            to={ROUTES.profile}
            onClick={handleAccountsMenuClose}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              cursor: "pointer",
              py: 0.5,
              color: T.text,
              "&:hover": { color: "#ffffff" },
            }}
          >
            <EditOutlinedIcon sx={{ fontSize: "16px", color: T.textMuted }} />
            <Typography sx={{ fontSize: "13px", color: "inherit" }}>
              Edit Account
            </Typography>
          </Box>
          <Box
            onClick={handleLogout}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              cursor: "pointer",
              py: 0.5,
              color: "#ef4444",
              "&:hover": { color: "#ff6b6b" },
            }}
          >
            <LogoutOutlinedIcon sx={{ fontSize: "16px", color: "inherit" }} />
            <Typography
              sx={{ fontSize: "13px", color: "inherit", fontWeight: 600 }}
            >
              Logout
            </Typography>
          </Box>
        </Box>
      </Menu>

      {/* ── FEEDBACK DIALOG ───────────────────────────────────── */}
      <Dialog
        open={feedbackOpen}
        onClose={handleFeedbackClose}
        maxWidth="sm"
        fullWidth
        sx={{ "& .MuiDialog-paper": { borderRadius: "16px" } }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: `1px solid ${theme.palette.divider}`,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <FeedbackIcon sx={{ color: theme.palette.text.color }} />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Share Your Feedback
            </Typography>
          </Box>
          <IconButton onClick={handleFeedbackClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ padding: "24px", mt: "10px" }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <Box>
              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                How would you rate your experience?
              </Typography>
              <Rating
                value={feedbackData.rating}
                onChange={(e, newValue) =>
                  setFeedbackData((prev) => ({ ...prev, rating: newValue }))
                }
                size="large"
                sx={{ "& .MuiRating-iconFilled": { color: "#FFB400" } }}
              />
            </Box>
            <Box>
              <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 600 }}>
                What type of feedback is this?
              </Typography>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {feedbackCategories.map((category) => (
                  <Chip
                    key={category}
                    label={category}
                    clickable
                    variant={
                      feedbackData.category === category ? "filled" : "outlined"
                    }
                    color={
                      feedbackData.category === category ? "info" : "default"
                    }
                    onClick={() =>
                      setFeedbackData((prev) => ({ ...prev, category }))
                    }
                    sx={{ borderRadius: "8px" }}
                  />
                ))}
              </Box>
            </Box>
            <TextField
              multiline
              rows={4}
              fullWidth
              placeholder="Please share your thoughts..."
              value={feedbackData.message}
              onChange={(e) =>
                setFeedbackData((prev) => ({
                  ...prev,
                  message: e.target.value,
                }))
              }
              label="Tell us more"
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
            />
            <TextField
              fullWidth
              placeholder="your.email@example.com"
              value={feedbackData.email}
              onChange={(e) =>
                setFeedbackData((prev) => ({ ...prev, email: e.target.value }))
              }
              label="Contact Email (optional)"
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ padding: "16px 24px 24px", gap: 1 }}>
          <Button
            onClick={handleFeedbackClose}
            sx={{ textTransform: "none", color: theme.palette.text.secondary }}
          >
            Cancel
          </Button>
          <Button
            disabled={
              !feedbackData.message.trim() ||
              feedbackData.rating === 0 ||
              feedbackSubmitting
            }
            startIcon={
              feedbackSubmitting ? <CircularProgress size={16} /> : <SendIcon />
            }
            variant="contained"
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              backgroundColor: "#006BCE",
              "&:hover": { backgroundColor: "#005bb5" },
            }}
          >
            {feedbackSubmitting ? "Sending..." : "Send Feedback"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Success message after feedback submitted */}
      <Snackbar
        open={showSuccessAlert}
        autoHideDuration={4000}
        onClose={() => setShowSuccessAlert(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setShowSuccessAlert(false)}
          severity="success"
          sx={{ borderRadius: "12px" }}
        >
          Thank you for your feedback!
        </Alert>
      </Snackbar>

      {/* Full-screen loading overlay while logging out */}
      <Backdrop
        open={isLoggingOut}
        sx={{
          color: "#fff",
          zIndex: (theme) =>
            Math.max(theme.zIndex.modal, theme.zIndex.snackbar) + 100,
          flexDirection: "column",
          gap: 2,
          backdropFilter: "blur(4px)",
        }}
      >
        <CircularProgress color="inherit" />
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Logging out securely...
        </Typography>
      </Backdrop>
    </Box>
  );
};

// --- REDUX WIRING ---
// mapStateToProps: reads values FROM the global Redux store into this component as props
const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.tk !== null,
  token: state.auth.tk,
  userDetails: state.auth.userDetails,
  authChecked: state.auth.authChecked,
});

// mapDispatchToProps: gives this component functions that DISPATCH actions to Redux
const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(actions.logout()),
  savePageContext: (newContext) =>
    dispatch(pageActions.savePageContext(newContext)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Navbar2),
);
